export default __webpack_public_path__ + "static/media/i360-logo-horizontal.c8b088f2.png";